module.exports = __webpack_public_path__ + "static/media/ui-face2.34300a5d.jpg";